/**
 * The console's own stylesheet, as a string.
 *
 * Not in `apps/web/src/styles.css`: that file is vB6's stylesheet, ported
 * unchanged by 026_customer_page, and the console has no business in it.
 * `/staff/emails` took the same decision in 028 for the same reason.
 *
 * Light only, as docs/overnight_constraints.md §1 requires of everything in
 * this project, and plain: §11.7 is a working surface, not a product.
 */
export const CONSOLE_STYLES = `
.plt-console { --ink:#17211b; --muted:#5d6b62; --line:#d8e0da; --bg:#f6f8f6;
  --green:#2f6b4f; --warn:#8a5a12; --warn-bg:#fdf4e3; --stop:#8c2f2f; --stop-bg:#fbeeee;
  --ok:#2f6b4f; --ok-bg:#eef5f0;
  font-family: Raleway, Arial, 'Helvetica Neue', Helvetica, sans-serif;
  color: var(--ink); background: var(--bg); min-height: 100vh; }
.plt-console * { box-sizing: border-box; }
.plt-console a { color: var(--green); }

.plt-console .bar { display:flex; gap:16px; align-items:baseline; flex-wrap:wrap;
  padding:12px 20px; background:#fff; border-bottom:1px solid var(--line); }
.plt-console .bar h1 { font-size:15px; margin:0; font-weight:700; letter-spacing:.02em; }
.plt-console .bar .who { margin-left:auto; font-size:13px; color:var(--muted); }
.plt-console .bar .env { font-size:11px; text-transform:uppercase; letter-spacing:.08em;
  border:1px solid var(--line); border-radius:3px; padding:1px 6px; color:var(--muted); }

.plt-console nav.menu { display:flex; gap:2px; flex-wrap:wrap; padding:0 20px;
  background:#fff; border-bottom:1px solid var(--line); }
.plt-console nav.menu a { display:block; padding:9px 12px; font-size:13px; text-decoration:none;
  color:var(--ink); border-bottom:2px solid transparent; }
.plt-console nav.menu a[aria-current='page'] { border-bottom-color:var(--green); font-weight:600; }
.plt-console nav.menu a.pending { color:var(--muted); font-style:italic; }

.plt-console main { padding:20px; max-width:1180px; }
.plt-console h2 { font-size:17px; margin:0 0 4px; }
.plt-console .lead { color:var(--muted); font-size:13px; margin:0 0 16px; }

.plt-console table { border-collapse:collapse; width:100%; background:#fff; font-size:13px; }
.plt-console th, .plt-console td { text-align:left; padding:7px 10px; border-bottom:1px solid var(--line);
  vertical-align:top; }
.plt-console th { font-size:11px; text-transform:uppercase; letter-spacing:.06em; color:var(--muted);
  background:#fbfcfb; }
.plt-console td.num, .plt-console th.num { text-align:right; font-variant-numeric:tabular-nums; }

.plt-console .card { background:#fff; border:1px solid var(--line); border-radius:4px;
  padding:14px 16px; margin:0 0 14px; }
.plt-console .card h3 { font-size:14px; margin:0 0 8px; }
.plt-console .grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:14px; }
.plt-console dl.facts { display:grid; grid-template-columns:auto 1fr; gap:3px 14px; margin:0; font-size:13px; }
.plt-console dl.facts dt { color:var(--muted); }
.plt-console dl.facts dd { margin:0; }

.plt-console .tag { display:inline-block; font-size:11px; border-radius:3px; padding:1px 6px;
  border:1px solid var(--line); background:#fff; color:var(--muted); margin:0 4px 2px 0; }
.plt-console .tag.warn { color:var(--warn); background:var(--warn-bg); border-color:#e8d6ac; }
.plt-console .tag.stop { color:var(--stop); background:var(--stop-bg); border-color:#e6c4c4; }
.plt-console .tag.ok   { color:var(--ok); background:var(--ok-bg); border-color:#c6ddcd; }

.plt-console button { font:inherit; font-size:13px; padding:6px 12px; border-radius:4px;
  border:1px solid var(--line); background:#fff; color:var(--ink); cursor:pointer; }
.plt-console button.primary { background:var(--green); border-color:var(--green); color:#fff; }
.plt-console button.danger { border-color:#d9b6b6; color:var(--stop); }
.plt-console button:disabled { opacity:.5; cursor:default; }
.plt-console .actions { display:flex; gap:8px; flex-wrap:wrap; margin-top:10px; }

.plt-console input[type=text], .plt-console input[type=number], .plt-console input[type=date],
.plt-console textarea, .plt-console select {
  font:inherit; font-size:13px; padding:6px 8px; border:1px solid var(--line); border-radius:4px;
  background:#fff; color:var(--ink); width:100%; max-width:420px; }
.plt-console label { display:block; font-size:12px; color:var(--muted); margin:8px 0 3px; }

/* Run 14 item 3: the quantity stepper on a dish line. One unit a press. */
.plt-console .qtystep { display:inline-flex; align-items:center; gap:4px; }
.plt-console .qtystep button { padding:4px 9px; line-height:1; font-size:14px; }
.plt-console .qtystep input[type=number] { text-align:right; }

.plt-console .note { background:#fff; border-left:3px solid var(--line); padding:8px 12px;
  font-size:13px; color:var(--muted); margin:0 0 12px; }
.plt-console .gap { background:var(--warn-bg); border-left-color:#e8d6ac; color:var(--warn); }
.plt-console .error { background:var(--stop-bg); border-left-color:#e6c4c4; color:var(--stop); }

.plt-console .signin { max-width:430px; margin:72px auto; background:#fff; border:1px solid var(--line);
  border-radius:6px; padding:26px 26px 20px; }
.plt-console .signin h2 { margin:0 0 6px; }
.plt-console .signin ul { list-style:none; padding:0; margin:12px 0 0; }
.plt-console .signin li { margin:0 0 7px; }
.plt-console .signin li button { width:100%; text-align:left; }
.plt-console .signin li small { display:block; color:var(--muted); font-size:11px; }
.plt-console .timeline { list-style:none; padding:0; margin:0; font-size:13px; }
.plt-console .timeline li { padding:6px 0; border-bottom:1px solid var(--line); }
.plt-console .timeline time { color:var(--muted); margin-right:10px; font-variant-numeric:tabular-nums; }

/* 390 px. §11.7 is a working surface and the people who use it carry phones:
   the review queue is answered on one as often as at a desk. A six-column
   table does not fit, and a table that does not fit does not merely look bad —
   the cells overlap and a button underneath one of them cannot be pressed,
   which is how this rule came to be written. So at narrow widths each row
   becomes a block and each cell a line of it. */
@media (max-width: 760px) {
  .plt-console main { padding:14px; }
  .plt-console table, .plt-console tbody, .plt-console tr, .plt-console td { display:block; width:100%; }
  .plt-console thead { display:none; }
  .plt-console tr { border-bottom:2px solid var(--line); padding:8px 0; }
  .plt-console td { border-bottom:0; padding:3px 10px; }
  .plt-console td.num { text-align:left; }
  .plt-console dl.facts { grid-template-columns:1fr; }
  .plt-console dl.facts dt { margin-top:6px; }
}
`
